<template>
  <div class="pk-book-view pk-flex">
    Slideset:
    <ul>
      <li v-for="(it,i) in items" :key="'res'+i">
        <router-link :to="{path:'/ae/set?ssid='+it._id}" @click.native="selectSlideset(it)">{{it.doc._source['54_ssmaintitle']}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      inputData: Object
    },
    data() {
      return {};
    },
    computed: {
      items() {
        return this.$store.getters.searchResult;
      }
    },
    methods: {
      selectSlideset(item) {
        this.$store.dispatch('archive.select.slideset', item);
        this.$store.dispatch('archive.select.navItem', 'slideset');
      }
    }

  };
</script>

<style scoped>
  a {
    cursor: pointer;
  }
</style>